<script setup lang="ts">
</script>

<template>
  <main>
    <h1>Страница не найдена</h1>
  </main>
</template>


<style scoped>
main {
  height: calc(100vh - 84px);
  display: flex;
  align-items: center;
  justify-content: center;
}

h1 {
  text-align: center;
}
</style>
